//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../Mechatronics/Mechatronics.CollisionShapeBuilder.js";
import "../no/Expression.js";
import "../no/SelectNXObject.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[1,"Angle",0,"Expression",0],[1,"AngularResolution",0,"Expression",0],[0,"Category",1,0],[1,"CycleTime",0,"Expression",0],[0,"GenerateSignals",1,0],[0,"Name",1,0],[1,"Range",0,"Expression",0],[1,"ScannerBody",0,"SelectNXObject",0],[1,"ScanningAngle",0,"Expression",0],[0,"ShowInSimulation",1,0]],[[["index","fieldSet","name","type","activity","points"],"CreateEvent",{},6,0],[["events"],"DeleteEvents",{},1,0],[["index","fieldSet"],"SetEventFieldSet",{},2,0],[["index","name"],"SetEventName",{},2,0],[["index","type"],"SetEventType",{},2,0],[["index","activity"],"SetEventActivity",{},2,0],[["index","points"],"SetEventPoints",{},2,0]],[]];
SPLM.Mechatronics.LaserScannerBuilder = class extends SPLM.Mechatronics.CollisionShapeBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.LaserScannerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;